import axios from '@/util/requestUtil'

// 查询艾德银行帐户-列表
export function getEddidBanksList (params) {
  return axios.get(`/fund/eddid/banks`, { params: params })
}

 // 查询客户资金记录
export function getFundRecord (params) {
  return axios.post('/fund/fund-records', params)
}

// 查询用户银行帐户-列表
export function getBanksList (params) {
  return axios.get(`/fund/banks`, { params: params })
}

// 提交-存款单
export function commitDeposit (params) {
  return axios.post('/fund/deposit/application', params)
}

// 存款最新记录
export function getDesposiRecords (params) {
  return axios.get('/fund/deposit/application/records', params)
}

// （用户）银行卡添加记录-列表
export function getBankAccountRecords (params) {
  return axios.get(`/fund/settlement/account/records`, params)
}

// 添加-用户银行卡
export function addUserBank (params) {
  return axios.post(`/fund/settlement/account/application`, params)
}

// 个人中心-提交-尽职审查单
export function submitDueDiligence (params) {
  return axios.post(`/eddid/due-diligence/application`, params)
}

// 查询艾德银行帐户-收款银行-列表-新版
export function getEddidBanks (params) {
  return axios.post(`/fund/eddid/queryBanks`, params)
}

// 查询用户子帐户
export function getSubAccountList (params) {
  return axios.get(`/fund/sub-account/bank`, { params: params })
}

// 协议条款链接
export function getAgreementContent (params) {
  return axios.post(`/eddid/agreement/content`, params)
}

// 获取协议内容
export function getTerms (url, params) {
  return axios.get(url, { params })
}

export function logout (params) {
  return axios.post(`${process.env.VUE_APP_AUTH}/v2/logout`, params)
}

// 我的银行卡-列表
export function getMyBank (params) {
  return axios.get(`/fund/myBank/list`, { params })
}

// 我的银行卡-操作记录
export function getmyBankRecords (params) {
  return axios.get(`/fund/myBank/record`, { params })
}

// 用户结算银行-列表(不传isSib时，查所有，true时，只查sib,false时，查非sib)
export function settlementAccount (params) {
  return axios.get(`/fund/settlementAccount/banks`, { params })
}

export function isAllowTrade (params) {
  return axios.get(`restricted/investor/pre-check`, { params })
}
